import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-portal-footer',
  standalone: true,
  templateUrl: './portal-footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './portal-footer.component.scss',
})
export class PortalFooterComponent {
  readonly currentYear = new Date().getFullYear();
}
